// extracted by mini-css-extract-plugin
export var navbarSubLink = "M_gb d_gb d_f4 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "M_wB d_f0 d_dz";
export var subPageLink = "M_gf d_gf";
export var burger = "M_wZ";
export var sublinkSize = "M_w0";
export var linkSize = "M_w1";
export var Link = "M_sM x_sM x_r5 x_sq";